export class Credentials {
  constructor(
    public email: string,
    public password: string
  ) { }
}



// WEBPACK FOOTER //
// /dist/src/app/user/credentials.model.ts